function cov_2go1scw3kb() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/sell/DocumentCard/DocumentCard.tsx";
  var hash = "060c75a4f42e78524597d4db1a3db7ea72ae7771";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/sell/DocumentCard/DocumentCard.tsx",
    statementMap: {
      "0": {
        start: {
          line: 49,
          column: 57
        },
        end: {
          line: 92,
          column: 1
        }
      },
      "1": {
        start: {
          line: 50,
          column: 62
        },
        end: {
          line: 50,
          column: 67
        }
      },
      "2": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 91,
          column: 4
        }
      },
      "3": {
        start: {
          line: 94,
          column: 54
        },
        end: {
          line: 122,
          column: 1
        }
      },
      "4": {
        start: {
          line: 95,
          column: 24
        },
        end: {
          line: 95,
          column: 63
        }
      },
      "5": {
        start: {
          line: 97,
          column: 2
        },
        end: {
          line: 103,
          column: 3
        }
      },
      "6": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 102,
          column: 6
        }
      },
      "7": {
        start: {
          line: 105,
          column: 2
        },
        end: {
          line: 118,
          column: 3
        }
      },
      "8": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 117,
          column: 6
        }
      },
      "9": {
        start: {
          line: 121,
          column: 2
        },
        end: {
          line: 121,
          column: 33
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 49,
            column: 57
          },
          end: {
            line: 49,
            column: 58
          }
        },
        loc: {
          start: {
            line: 49,
            column: 68
          },
          end: {
            line: 92,
            column: 1
          }
        },
        line: 49
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 94,
            column: 54
          },
          end: {
            line: 94,
            column: 55
          }
        },
        loc: {
          start: {
            line: 94,
            column: 65
          },
          end: {
            line: 122,
            column: 1
          }
        },
        line: 94
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 68,
            column: 21
          },
          end: {
            line: 68,
            column: 87
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 68,
            column: 47
          },
          end: {
            line: 68,
            column: 75
          }
        }, {
          start: {
            line: 68,
            column: 78
          },
          end: {
            line: 68,
            column: 87
          }
        }],
        line: 68
      },
      "1": {
        loc: {
          start: {
            line: 71,
            column: 11
          },
          end: {
            line: 76,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 11
          },
          end: {
            line: 71,
            column: 35
          }
        }, {
          start: {
            line: 72,
            column: 12
          },
          end: {
            line: 75,
            column: 19
          }
        }],
        line: 71
      },
      "2": {
        loc: {
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 103,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 97,
            column: 2
          },
          end: {
            line: 103,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 97
      },
      "3": {
        loc: {
          start: {
            line: 105,
            column: 2
          },
          end: {
            line: 118,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 105,
            column: 2
          },
          end: {
            line: 118,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 105
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "060c75a4f42e78524597d4db1a3db7ea72ae7771"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2go1scw3kb = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2go1scw3kb();

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Box, Button, Card, Flex, Icon, Link, Text } from '@opendoor/bricks/core';
cov_2go1scw3kb().s[0]++;

/**
 * A component that renders a downloadable document as a Card
 *
 * If type is external link or button, tracks click as:
 * `document-tile-link-${props.name}`
 *
 * component-test-check-ignore
 */
export var DocumentCard = function DocumentCard(props) {
  cov_2go1scw3kb().f[0]++;

  var _ref = (cov_2go1scw3kb().s[1]++, props),
      id = _ref.id,
      name = _ref.name,
      subText = _ref.subText,
      testIndex = _ref.testIndex,
      marginProps = _ref.marginProps,
      type = _ref.type;

  cov_2go1scw3kb().s[2]++;
  return /*#__PURE__*/React.createElement(Card, _extends({
    key: id,
    role: "group",
    "aria-label": "document",
    height: "auto",
    variant: "secondary",
    py: [5, 5, 5],
    pr: [5, 5, 5]
  }, marginProps), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    outline: "0",
    p: 0,
    justifyContent: "space-between",
    width: "100%",
    "data-testid": testIndex !== undefined ? (cov_2go1scw3kb().b[0][0]++, "document-tile-".concat(testIndex)) : (cov_2go1scw3kb().b[0][1]++, undefined)
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    justifyContent: "center"
  }, (cov_2go1scw3kb().b[1][0]++, type === 'external-link') && (cov_2go1scw3kb().b[1][1]++, /*#__PURE__*/React.createElement(Flex, {
    mr: 5,
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "pdf",
    color: "neutrals100",
    size: 24
  }))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    fontSize: "s1",
    lineHeight: "s1",
    fontWeight: "normal",
    color: "neutrals100"
  }, name), /*#__PURE__*/React.createElement(Text, {
    fontSize: "s00",
    fontWeight: "normal",
    color: "neutrals90"
  }, subText))), /*#__PURE__*/React.createElement(Flex, {
    mx: 3,
    alignItems: "center",
    cursor: "pointer",
    justifyContent: "end"
  }, /*#__PURE__*/React.createElement(ClickableSection, props))));
};
cov_2go1scw3kb().s[3]++;

var ClickableSection = function ClickableSection(props) {
  cov_2go1scw3kb().f[1]++;
  var analyticsName = (cov_2go1scw3kb().s[4]++, "cake-document-tile-link-".concat(props.name));
  cov_2go1scw3kb().s[5]++;

  if (props.type === 'external-link') {
    cov_2go1scw3kb().b[2][0]++;
    cov_2go1scw3kb().s[6]++;
    return /*#__PURE__*/React.createElement(Link, {
      href: props.href,
      analyticsName: analyticsName,
      "aria-label": null
    }, props.children);
  } else {
    cov_2go1scw3kb().b[2][1]++;
  }

  cov_2go1scw3kb().s[7]++;

  if (props.type === 'button') {
    cov_2go1scw3kb().b[3][0]++;
    cov_2go1scw3kb().s[8]++;
    return /*#__PURE__*/React.createElement(Button, {
      analyticsName: analyticsName,
      onClick: props.onClick,
      variant: "link",
      "aria-label": null,
      "data-testid": "document-tile-link-".concat(props.testIndex),
      fontWeight: "semibold"
    }, "View");
  } else {
    cov_2go1scw3kb().b[3][1]++;
  } // custom link


  cov_2go1scw3kb().s[9]++;
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.customLink);
};